export const SINGLE_TABLE_TEST_ID = {
  row: 'data-row',
  button: 'data-single-table-button',
};
